import { render, staticRenderFns } from "./watch-card-del.vue?vue&type=template&id=64e2233b"
import script from "./watch-card-del.vue?vue&type=script&lang=js"
export * from "./watch-card-del.vue?vue&type=script&lang=js"
import style0 from "./watch-card-del.vue?vue&type=style&index=0&id=64e2233b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports